<template>
  <el-footer>
    <div class="line_cla">
      版权所有：济南市历城区精神卫生防治中心
    </div>
    <div class="line_cla">
    ICP备案：<a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2025165089号-1</a>
    </div>
    <div class="line_cla">
      ©{{year}} www.lcjfzx.cn All Rights Reserved
    </div>
    <!--<div class="line_cla">
      地址: 济南市南部山区锦绣川车川村79号
    </div>
    <div class="line_cla">
      乘车路线：65路公交车直达
    </div>-->
  </el-footer>
</template>

<script>
  export default {
    name: "footView",
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>

<style scoped>
  .el-footer {
    background-color: #EEEEEE;
    text-align: center;
    height: 100% !important;
    line-height: 10%;
    padding: 15px 20px 5px 20px;
  }

  .line_cla {
    font-size: 14px;
    font-family: FangSong;
    color: #888888;
    line-height: 17px;
    padding: 2px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/headerView/AppFootView.vue